import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";

import { postSubmitForm } from "../../../helpers/forms_helper";
import moment from "moment";
import { formatUnitsForReport } from "../../../helpers/units";
import preloader from "../../../helpers/preloader";
import showNotification from "../../../helpers/show_notification";
import calculatePrice from "../../../helpers/calculate_price";
import SweetAlert from "react-bootstrap-sweetalert";
import printDiv from "../../../helpers/print_data";

const ViewPO_Owner = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const [allBranches, setAllBranches] = useState([]);
  const { SearchBar } = Search;

  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
    loadAllBranches();
  }, []);

  const [allPO, setAllPO] = useState([]);
  const loadAllPO = async () => {
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setAllPO([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setAllPO([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      preloader(true);
      setAllPO([]);
      let allData = [];
      let url =
        process.env.REACT_APP_BASEURL + "purchaseorders/getall_for_approval";
      if (daysDiff > 5) {
        // Split into 4 parts
        const daysPerPart = Math.ceil(daysDiff / 4);
        let startDate = moment(dateFrom);
        let endDate = moment(dateTo);

        for (let i = 0; i < 4; i++) {
          const currentEndDate = moment.min(
            startDate.clone().add(daysPerPart, "days"),
            endDate,
          );

          const response = await postSubmitForm(url, {
            date_from: startDate.format("YYYY-MM-DD"),
            date_to: currentEndDate.format("YYYY-MM-DD"),
          });

          if (response && response.status === 1) {
            let result = response.data || [];
            allData = [...allData, ...result];
          } else {
            // showNotification(response.message || "Error", "Error");
          }

          startDate = currentEndDate.clone().add(1, "day");
          if (startDate.isAfter(endDate)) break;
        }
      } else {
        // Single API call
        const response = await postSubmitForm(url, {
          date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
          date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
        });

        if (response && response.status === 1) {
          let result = response.data || [];
          allData = [...allData, ...result];
        } else {
          showNotification(response.message || "Error", "Error");
        }
      }
      if (allData.length <= 0) {
        showNotification("No Orders data found", "error");
      }
      preloader(false);
      setAllPO(allData);
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "branches/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllBranches(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const sendEmail = async (id) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "purchaseorders/email_by_id";
    const response = await postSubmitForm(url, { id: id });

    if (response && response.status === 1) {
      preloader(false);
      showNotification("Email sent successfully", "Success");
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const [confirmResendNewPO, setConfirmResendNewPO] = useState(false);
  const resendNewPo = async () => {
    try {
      if (selectedPO.items?.length <= 0) return;
      const itemsForPO = selectedPO.items.map((item) => {
        return {
          item_id: item.item_id,
          name: item.name,
          brand: item.brand,
          category: item.category,
          price: +item.price,
          unit_for_po: item.unit_for_po,
          total_price: calculatePrice(
            item.unit_levels,
            item.receive,
            item.price,
            item.unit_for_po,
          ),
          sub_category: item.sub_category,
          quantity: item.receive.map(({ unit, value }) => ({ unit, value })),
          unit_levels: item.unit_levels.map(({ unit, value }) => ({
            unit,
            value,
          })),
        };
      });
      let payload = {
        id: selectedPO._id,
        supplier: selectedPO.supplier,
        branch_details: selectedPO.branch_details,
        item_details: itemsForPO,
        item_total_price: itemsForPO.reduce(
          (acc, curr) => acc + curr.total_price,
          0,
        ),
      };
      switch (selectedPO.branch_details.type) {
        case "CENTRAL STORE":
          Object.assign(payload, {
            deliver_at_branch: false,
          });
          break;
        case "CENTRAL KITCHEN STORE":
          Object.assign(payload, {
            deliver_at_branch: selectedPO.deliver_at_branch,
          });
          break;
        case "Branch":
          Object.assign(payload, {
            deliver_at_branch: selectedPO.deliver_at_branch,
          });
          break;
        case "Sub Store":
          Object.assign(payload, {
            deliver_at_substore: selectedPO.deliver_at_substore,
          });
          break;
        case "Main Store":
          Object.assign(payload, {
            deliver_at_mainstore: selectedPO.deliver_at_mainstore,
          });
          break;
      }

      // console.log(payload,"pl"); return
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "purchaseorders/insert_partial";
      const response = await postSubmitForm(url, payload);

      if (response && response.status === 1) {
        preloader(false);
        window.open(`/purchase_order?po_id=${response.data}`, "_blank");
        showNotification(
          "New PO generated for remaining items and current PO closed",
          "Success",
        );
        setSelectedPO();
        loadAllPO();
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      preloader(false);
      showNotification(error.message, "Error");
    }
  };

  const [itemsModal, setItemsModal] = useState();
  const [selectedPO, setSelectedPO] = useState();

  function editFormatter(cell, row) {
    return (
      <>
        <span className=" mr-2">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedPO(row);
              setItemsModal(!itemsModal);
            }}
          ></i>
        </span>
        <span className="mr-2 text-info">
          <a
            href={"/purchase_order?po_id=" + row._id}
            target="_blank"
            className="font-size-11"
          >
            <i
              className="mdi mdi-printer font-size-15"
              title="Print PO"
              style={{ cursor: "pointer" }}
            ></i>
          </a>
        </span>
        {row.status != "Pending Approval" &&
          row.status != "Rejected" &&
          row.status != "Closed" && (
            <span className=" mr-2">
              <i
                className="bx bx-mail-send font-size-15"
                title="Send Email"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  sendEmail(row._id);
                }}
              ></i>
            </span>
          )}

        {row.status === "Partially Delivered" && (
          <span className=" mr-2">
            <i
              className="mdi mdi-text-box-plus-outline font-size-15"
              title="Generate New PO for remaining items"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedPO(row);
                setConfirmResendNewPO(true);
              }}
            ></i>
          </span>
        )}
      </>
    );
  }

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("PO ID"),
      dataField: "po_id",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Store/Branch Name"),
      dataField: "branch_details.name",
      sort: true,
      // formatter: (cell, row) =>
      //   row.branch_details ? row.branch_details.name : "CENTRAL STORE",

      filter: selectFilter({
        options: () => {
          const branch_allpo = allPO.filter((item) => item.branch_details);
          const unique = [
            ...new Map(
              [
                ...new Set(
                  branch_allpo.map(({ branch_details: value }) => ({
                    value: value.name,
                    label: value.name,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          //unique.push({ value: "CENTRAL STORE", label: "CENTRAL STORE" });
          unique.sort(dynamicSort("label"));
          //console.log(unique);
          return unique;
        },
      }),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Deliver at Store/Branch"),
      sort: true,
      formatter: (cell, row) => {
        switch (row.branch_details?.type) {
          case "Branch":
            return row.deliver_at_branch ? "Yes" : "No";
          case "Main Store":
            return row.deliver_at_mainstore ? "Yes" : "No";
          case "Sub Store":
            return row.deliver_at_substore ? "Yes" : "No";
          case "CENTRAL KITCHEN STORE":
            return row.deliver_at_branch ? "Yes" : "No";
          default:
            return "";
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Supplier Info"),
      dataField: "supplier.name",
      sort: true,
      headerStyle: () => ({ width: "15%" }),
      formatter: (cell, row) => (
        <div>
          <div>{row.supplier?.name}</div>
          <small className="text-muted">
            <i className="mdi mdi-phone mr-1"></i>
            {row.supplier?.mobile}
          </small>
        </div>
      ),
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ supplier: value }) => ({
                    value: value?.name,
                    label: value?.name,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
        placeholder: "All",
      }),
    },
    {
      dataField: "item_total_price",
      text: props.t("Amount"),

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (cell, row) =>
        moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "status",
      text: props.t("Status & Details"),
      sort: true,
      headerStyle: () => ({ width: "15%" }),
      formatter: (cell, row) => (
        <div>
          <div className={`badge badge-${getStatusBadgeColor(cell)}`}>
            {cell}
          </div>
          {row.status === "Closed" && (
            <div className="mt-1 small">
              {row.closing_remark && (
                <div className="text-muted">
                  <i className="mdi mdi-comment-text-outline mr-1"></i>
                  {row.closing_remark}
                </div>
              )}
              {row.manual_closed_by && (
                <div className="text-muted">
                  <i className="mdi mdi-account mr-1"></i>
                  Closed by: {row.manual_closed_by}
                </div>
              )}
            </div>
          )}
          {row.status !== "Pending" && row.received_by && (
            <div className="text-muted small">
              <i className="mdi mdi-account-check mr-1"></i>
              Received by: {row.received_by}
            </div>
          )}
        </div>
      ),
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ status: value }) => ({
                    value: value,
                    label: value,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
        placeholder: "All",
      }),
    },
    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending":
      case "Pending Approval":
        return "warning";
      case "Partially Delivered":
        return "info";
      case "Closed":
        return "secondary";
      default:
        return "primary";
    }
  };

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "30%" };
      },
      editable: false,
      footer: true,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
      footer: true,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
      footer: true,
    },

    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.price + "/" + row.unit_for_po;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: true,
    },

    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
      footer: true,
    },
    {
      dataField: "total_price",
      text: props.t("Total"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,

      footer: (columnData) =>
        columnData.reduce((acc, item) => Number((acc + item).toFixed(2)), 0),
    },
  ];

  const handleDownload = async () => {
    const fileName = "all_po";
    const exportType = "xls";

    let data_to_export = allPO;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          po_id: v.po_id,
          branch_name: v.branch_details.name,
          category: v.category,
          supplier_name: v.supplier.name,
          supplier_mobile: v.supplier.mobile,
          createdAt: v.createdAt,
          status: v.status,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.is_email_sent) {
      style.backgroundColor = "#b0ff9e";
    }
    return style;
  };

  const handleApprovePO = async () => {
    let url = process.env.REACT_APP_BASEURL + "purchaseorders/approve";

    let response = await postSubmitForm(url, {
      purchaseorder_id: selectedPO._id,
    });
    if (response.status === 1) {
      loadAllPO();
      setItemsModal(false);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleRejectPO = async () => {
    let url = process.env.REACT_APP_BASEURL + "purchaseorders/reject";

    let response = await postSubmitForm(url, {
      purchaseorder_id: selectedPO._id,
    });
    if (response.status === 1) {
      loadAllPO();
      setItemsModal(false);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Requisition")}
            alternateTitle={props.t("Purchase Orders")}
            breadcrumbItem1={props.t("All Purchase Orders")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>

                      <Col lg={3}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllPO();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allPO && allPO}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4} className="text-center">
                              <CardTitle>All Purchase Orders</CardTitle>
                            </Col>
                            <Col lg={4} className="text-right">
                              {/* <button
                              className="btn-sm btn btn-info"
                              onClick={() => {
                                setAddInventoryModal(!addInventoryModal);
                              }}
                            >
                              Add Item
                            </button> */}
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    isOpen={itemsModal}
                    toggle={() => setItemsModal(!itemsModal)}
                  >
                    <ModalHeader toggle={() => setItemsModal(!itemsModal)}>
                      Purchase Order ID: {selectedPO && selectedPO.po_id}{" "}
                    </ModalHeader>
                    <ModalBody>
                      {selectedPO && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Label>Ordered Items</Label>
                              <ToolkitProvider
                                keyField="_id"
                                data={selectedPO && selectedPO.items}
                                columns={columns_items}
                              >
                                {(props) => (
                                  <div>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      cellEdit={cellEditFactory({
                                        mode: "click",
                                        blurToSave: true,
                                      })}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                  </div>
                                )}
                              </ToolkitProvider>
                            </Col>
                            {selectedPO.deliver_at_branch !== true &&
                              selectedPO.status !== "Delivered" &&
                              selectedPO.status !== "Closed" && (
                                <>
                                  <Col lg={12} className="text-center">
                                    <Button
                                      type="submit"
                                      color="primary"
                                      className="btn btn-default waves-effect waves-light"
                                      onClick={handleApprovePO}
                                    >
                                      {props.t("Approve")}
                                    </Button>{" "}
                                    <Button
                                      type="submit"
                                      color="danger"
                                      className="btn btn-default waves-effect waves-light"
                                      onClick={handleRejectPO}
                                    >
                                      {props.t("Reject")}
                                    </Button>{" "}
                                  </Col>
                                </>
                              )}
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {confirmResendNewPO && (
            <SweetAlert
              title={props.t("Are you sure?")}
              warning
              showCancel
              cancelBtnText={props.t("No")}
              confirmBtnText={props.t("Yes")}
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => {
                setConfirmResendNewPO(false);
                resendNewPo();
              }}
              onCancel={() => {
                setConfirmResendNewPO(false);
              }}
            >
              {props.t(
                "Once you click a new purchase order will be created for the remaining items, and the current PO will be closed. This action cannot be undone.",
              )}
            </SweetAlert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewPO_Owner)),
);
